const ko = {
    // 操作
    addProduct: "제품 추가",

    code: "재고 코드",
    name: "재고 이름",
    uom: "주요 측정 단위",
    cbm: "입방미터",
    brand1: "모델 1",
    brand2: "모델 2",

    // 表单
    plCode: '주식코드를 입력해주세요',
    plCodeRule: "재고 코드 길이는 최소 {{min}}자리, 최대 {{max}}자리입니다.",
    plName: '주식 이름을 입력하세요',
    plInputMaxRule: "인벤토리 이름은 {{length}}자를 초과할 수 없습니다.",
    plCbm: "입방미터를 입력하세요",
    plDesc: "설명을 입력하세요",
    plBrand1: "모델 1을 입력하세요",
    plBrand2: "모델 2를 입력하세요",
    plUom: '마스터 측정 단위를 선택하십시오.',

    category: "카테고리",
    addFailed: "추가 실패",
    modifySuccess: "수정 성공",
    modifyFailed: "수정 실패",
    addChildNode: "자식 노드 추가",
    clickModify: "클릭하여 수정하세요",
    serialNum: "일련 번호",
    addCategory: "카테고리 추가",
    addType: "제품 유형 추가",
    selProduct: "제품을 선택해주세요",
    priPrducInfo: "제품 정보 인쇄",
    priThisPage: "이 페이지 내용 인쇄",
    modify: "수정",
    plFill: "필수 항목을 입력해 주세요!",
    modifyProduct: "제품 수정",
    process: "프로세스",
    processPl: "절차를 선택하십시오.",
    materialProcess: "재료 공정",
    cbmDecimalLength: "소수점 자릿수는 {{count}}을(를) 초과할 수 없습니다",

    gallery: '갤러리',
    folder: '폴더',
    dataError: '데이터 오류, 관리자에게 연락하여 정보를 수정하고 다시 시도하세요',
    productInfo: '제품 정보',
    num: '재고 수량',
    model: '재고 모델',
    preReady: '상비 재료',
    isTrue: '예',
    isFalse: '否아니오',
    isDeprecated: '폐기 여부',
    deprecated: '폐기',
    normalStatus: '정상',
    notSet: '미설정',
    returnQuantity: "반품 수량",
    noReturnQuantity: "반품 상품 없음",

    // 생산 자료
    createProductInfo: "생산 자료 생성",
    editProductInfo: "생산 자료 편집",
    viewProductInfo: "생산 자료 보기",
    selectSaleOrder: "판매 주문 선택",
    orderNumber: "주문 번호",
    erpCode: "ERP 코드",
    issueDate: "발행일",
    customerName: "고객명",
    customerModel: "고객 모델",
    companyModel: "회사 모델",
    productionSoftware: "생산 소프트웨어",
    flash: "플래시 소프트웨어",
    md5Value: "MD5 값",
    checksum: "체크섬",
    qaToolVersion: "QA 도구 버전",
    softwareVersion: "소프트웨어 버전",
    macAddressContent: "MAC 주소 내용",
    quantity: "수량",
    size: "크기",
    antivirusStatus: "바이러스 백신 상태",
    languageRequirement: "언어 요구사항",
    ssid: "SSID",
    initialIp: "초기 IP",
    finishedToolVersion: "완제품 도구 버전",
    semiFinishedToolVersion: "반완제품 도구 버전",
    channelRange: "채널 범위",
    channelSelection: "채널 선택",
    defaultChannel: "기본 채널",
    functionDescription: "기능 설명",
    productionTestProgram: "생산 테스트 프로그램",
    power: "전력",
    evm: "EVM",
    fer: "FER",
    smt: "SMT",
    dip: "DIP",
    test1: "테스트 1",
    assy: "조립",
    test2: "테스트 2",
    pack: "포장",
    shipmentRequirements: "발송 요구사항",
    plSelectSaleOrder: "판매 주문을 선택해주세요",
    attachments: "첨부 이미지",
    uploadImage: "이미지 업로드",
    plUploadImage: "이미지를 업로드해주세요",
    uploadFailed: "업로드 실패",
    imageSelected: "이미지 선택됨",
    onlyImageAllowed: "이미지 업로드만 허용됩니다",
    clickOrDragUpload: "클릭하거나 파일을 드래그하여 여기에 업로드",
    descriptionPlaceholder: "설명 (선택 사항)",
    addAttachment: "첨부 이미지 추가",
    languageZh: "중국어",
    languageEn: "영어",
    languageTr: "중국어 번체",
    languageVn: "베트남어",
    languageKo: "한국어",
    languageFr: "프랑스어",
    languageDe: "독일어",
    languageRu: "러시아어",
    languageAdaptive: "적응형",
    languagePortuguese: "포르투갈어, 기타",
    region36to165: "영역 36-165",
    basicInfo: "기본 정보",
    productionInfo: "생산 정보",
    testInfo: "테스트 정보",
    shipmentInfo: "발송 정보",
    delete: "삭제",
    basicInfoDesc: "기본 정보 설명",
    testProgram: "테스트 프로그램",
    testProgramFinished: "테스트 프로그램 - 완제품 도구 버전",
    testProgramSemiFinished: "테스트 프로그램 - 반완제품 도구 버전",
    auto: "자동",
    addSuccess: "생성 성공",
    addSuccessDesc: "생산 자료가 성공적으로 생성되었습니다",
    editSuccess: "수정 성공",
    editSuccessDesc: "생산 자료가 성공적으로 수정되었습니다",
    editFailed: "수정 실패",
    saleOrderAlreadyHasProductInfo: "판매 주문 번호: {{orderNumber}}，이미 생산 자료가 생성되었습니다",

    // 리스트 페이지
    normalTab: "정상",
    disabledTab: "비활성화",
    salesOrderNumber: "판매 주문 번호",
    internalNumber: "내부 번호",
    createdAt: "생성 시간",
    updatedAt: "업데이트 시간",
    action: "작업",
    disable: "비활성화",
    enable: "활성화",
    disableConfirm: "비활성화 확인",
    enableConfirm: "활성화 확인",
    disableConfirmDesc: "생산 자료를 비활성화하시겠습니까?",
    enableConfirmDesc: "생산 자료를 활성화하시겠습니까?",
    disableSuccess: "비활성화 성공",
    enableSuccess: "활성화 성공",
    disableFailed: "비활성화 실패",
    enableFailed: "활성화 실패",
    searchPlaceholder: "제품 ID 또는 설명서 이름을 입력하여 검색하세요",
    batchExport: "일괄 내보내기",
    minStockCount: "최소 재고",
    maxStockCount: "최대 재고",
    minStockAgeDays: "최소 재고 보관일(일)",
    maxStockAgeDays: "최대 재고 보관일(일)",
    codePl: "자재 번호 입력",
    alertAdd: "경고 추가",
    alertDetail: "경고 정보",
    overMaxCount: "최대 재고 초과: {{maxStockCount}}",
    lowerMinCount: "최소 재고 미달: {{minStockCount}}",
    alert: "경고",
    hh: "항습",
    ht: "항온",
    va: "진공",
    ot: "기타",
    storeType: "보관 요구사항",
    storageCode: "요구사항 유형",
    minValue: "하한",
    maxValue: "상한",
    unit: "단위",
    inspectionCycleDays: "점검 주기(일)",
};

export default ko;